export default "__VITE_ASSET__Dt7J9CRa__"